module.exports = __webpack_public_path__ + "img/1F1EF-1F1F2.8e82a59b.svg";